services.service('ErrorService', ['constants', function (Const) {
    function ErrorService(errorData, isLog) {
        this.source = errorData.source;
        this.type = errorData.type;
        this.code = errorData.code || 0;
        this.severity = errorData.severity || 'critical';
        this.message = errorData.message;
        this.data = errorData.data;
    }

    ErrorService.prototype = Object.create(Error.prototype);
    ErrorService.prototype.constructor = ErrorService;

    return ErrorService;
}]);